import Loan from "typedef/Loan";
import useDefineLoanType from "./useDefineLoanType";
import HELOCForm from "components/HELOCForm";

const TypeOfCreditLineOptions: React.FC<{ loan: Loan }> = ({ loan }) => {
  const offer = useDefineLoanType(loan);

  return <HELOCForm {...offer} />;
};

export default TypeOfCreditLineOptions;
